import constants from '../../../modules/constants';
import { bulkTranslation } from 'Base/modules/bk/component-property-providers/bk-translations';
import './styles.scss';

class PageFooter extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const texts = bulkTranslation({
            bkag: 'global.bkag',
            version: 'global.BKMS.version',
            impressum: 'client.impressum',
            impressumHtml: 'client.impressum.html',
        });

        this.innerHTML += `
            <footer class="bk-footer">
                <div class="bk-footer__content">
                   <div class="bk-footer__left">
                      <a class="bk-footer__link" href="https://www.eqs.bkms-system.com/" target="_blank">${texts.bkag}</a>
                      <span class="bk-footer__text">
                        ${constants.GLOBAL_BKMS_HTML}
                        <span id="bk-version" >${texts.version}</span>
                      </span>
                      <bk-button-secondary data-imprint bk-text="${texts.impressum}" class="bk-footer__button-secondary"></bk-button-secondary>
                   </div> 
                </div>
            </footer>
            <bk-modal></bk-modal>
        `;

        this.querySelector('[data-imprint]').addEventListener('click', function () {
            // TODO: make impressum component
            const content = texts.impressumHtml;
            document.querySelector('bk-modal')?.openModal({ bodyContent: content });
        });
    }
}

export default PageFooter;
